import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as FlightService from '_services/flight-service';

const initialState = {
    outboundFlights: [],
    inboundFlights: [],
    inboundForecastedFlights: [],
    outboundForecastedFlights: [],
    tab: 'outbound',
    status: 'idle',
    error: null
};

export const getOutboundFlights = createAsyncThunk('flights/getOutboundFlights', async (params) => {
    return FlightService.getFlights(params);
});

export const getInboundFlights = createAsyncThunk('flights/getInboundFlights', async (params) => {
    return FlightService.getFlights(params);
});

export const getInboundFlightsForecast = createAsyncThunk('flights/getInboundFlightsForecast', async (params) => {
    return FlightService.getFlightsForecast(params);
});

export const getOutboundFlightsForecast = createAsyncThunk('flights/getOutboundFlightsForecast', async (params) => {
    return FlightService.getFlightsForecast(params);
});


const flightsSlice = createSlice({
  name: 'flights',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setTab: (state, action) => {
      state.tab = action.payload
    }
  },
  extraReducers: {
    [getOutboundFlights.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [getOutboundFlights.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        outboundFlights: action.payload,
      }
    },
    [getOutboundFlights.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message,
      }
    },
    [getInboundFlights.pending]: (state, action) => {
        return {
          ...state,
          status: 'loading',
        }
    },
    [getInboundFlights.fulfilled]: (state, action) => {
        return {
          ...state,
          status: 'succeeded',
          inboundFlights: action.payload,
        }
    },
    [getInboundFlights.rejected]: (state, action) => {
        return {
          ...state,
          status: 'failed',
          error: action.error.message,
        }
    },
    [getInboundFlightsForecast.pending]: (state, action) => {
        return {
          ...state,
          status: 'loading',
        }
    },
    [getInboundFlightsForecast.fulfilled]: (state, action) => {
        return {
          ...state,
          status: 'succeeded',
          inboundForecastedFlights: action.payload,
        }
    },
    [getInboundFlightsForecast.rejected]: (state, action) => {
        return {
          ...state,
          status: 'failed',
          error: action.error.message,
        }
    },
    [getOutboundFlightsForecast.pending]: (state, action) => {
        return {
          ...state,
          status: 'loading',
        }
    },
    [getOutboundFlightsForecast.fulfilled]: (state, action) => {
        return {
          ...state,
          status: 'succeeded',
          outboundForecastedFlights: action.payload,
        }
    },
    [getOutboundFlightsForecast.rejected]: (state, action) => {
        return {
          ...state,
          status: 'failed',
          error: action.error.message,
        }
    }
  }
});

export const { reset, setTab } = flightsSlice.actions;

export const selectTab = state => state.flights.tab;

export const selectInboundFlightsForecast = state => {
  return state.flights.inboundForecastedFlights;
} 

export const selectOutboundFlightsForecast = state => {
  return state.flights.outboundForecastedFlights;
}

export const selectDepartures = state => {
    return state.flights.outboundFlights;
};

export const selectArrivals = state => {
    return state.flights.inboundFlights;
}

/*
export const selectInboundFlights = state => {

    let forecastedFlights = [...state.flights.inboundForecastedFlights];
    
    let passengerCount = 0;
    let forecastedCount = 0;

    // process each flight into formatting for the table
    let list = state.flights.inboundFlights.map(flight => {

        // extract flight number
        let flightNumber = flight.flight;
        let isForecasted = false;
        let forecastedFlightDoc = {};

        // check if flight is part of forecasted flight list
        forecastedFlights.forEach((forecastedFlight) => {
          // console.log('forecasted flight ', forecastedFlight)
          // check if flight numbers match
          //console.log('checking for match ', forecastedFlight.flight + ' with : ' + flightNumber)
          if(forecastedFlight.flight === flightNumber){
            isForecasted = true;
            forecastedFlightDoc = forecastedFlight;
          }
        });

        // increment passenger count
        passengerCount += flight.passengerCount;
        forecastedCount += forecastedFlightDoc == undefined || forecastedFlightDoc.passengerForecastCount == undefined ? 0 : forecastedFlightDoc.passengerForecastCount;


        // create object combing flight and forecasted data
        return {
            date: flight.date,
            flight: flightNumber,
            passengerCount: flight.passengerCount,
            isForecasted: isForecasted,
            forecastedCount: forecastedFlightDoc.passengerForecastCount == undefined ? null : forecastedFlightDoc.passengerForecastCount.toFixed(1),
            forecastedFlightDoc: forecastedFlightDoc
        };
    });

    let tally = {
      date:'Total', flight: 'All Flights', 'passengerCount': passengerCount, 'forecastedCount': forecastedCount, forecastedFlightDoc: {}
    }

    list.push(tally)

    return list;
};
*/

export const selectInboundFlights = state => {

  let forecastedFlights = [...state.flights.inboundForecastedFlights];       // forecast passenger flight count { flight, date, forecastedCount }
  let inboundFlights = [...state.flights.inboundFlights];                       // actual passenger flight count { flight, date, passengerCount }

  if(inboundFlights  == null || inboundFlights == undefined || inboundFlights.length == 0){ return [] }
  if(forecastedFlights == null || forecastedFlights == undefined || forecastedFlights.length == 0){ return [] }

  // console.log('real flights ', realFlights)             // actual passenger flight count { flight, date, passengerCount }
  
  let passengerCount = 0;
  let forecastedCount = 0;

  let duplicateList = [];

  // console.log('forecasted flights ', forecastedFlights)

  forecastedFlights.forEach((forecastedFlight) => {
    let count = 0;

    forecastedFlights.forEach((flight) => {
      if(forecastedFlight.flight == flight.flight){
        count++
      }
    }) 

    if(count > 1){
      duplicateList.push(forecastedFlight)
    }
  })

  // console.log('arrivals duplicate list ', duplicateList)

  // before processing, remove any duplicates from forecasted flights
  /*
  const uniqueList = Array.from(
    new Map(forecastedFlights.map(item => [item.flight, item])).values()
  );
  */
  //console.log('unique list ', uniqueList)

  let list = forecastedFlights.map(forecastedFlight => {

    // add forecasted passengers to total forecast flight count
    forecastedCount += forecastedFlight.passengerForecastCount;

    // extract flight number from forecasted flight
    let flightNumber = forecastedFlight.flight;

    // find outbound flight object if its exsists
    const inboundFlight = inboundFlights.find(inboundFlight => inboundFlight.flight === flightNumber);
 
    if(inboundFlight == undefined){
      // this flight is forecasted but there are currently no passengers booked on the outbound flight
      return {
        date: forecastedFlight.date,
        flight: flightNumber,
        passengerCount: 0,
        forecastedCount: forecastedFlight.passengerForecastCount,
        forecastedFlightDoc: forecastedFlight
      };
    }
    else {

      // console.log('outbound flight ', outboundFlight)

      // increment passenger count
      passengerCount += inboundFlight.passengerCount;
      
      // create object combing flight and forecasted data
      return {
          date: forecastedFlight.date,
          flight: flightNumber,
          passengerCount: inboundFlight.passengerCount,
          forecastedCount: forecastedFlight.passengerForecastCount,
          forecastedFlightDoc: forecastedFlight
      };
  }
});

// find which flights are missing from the forecast
let missingFlights = [];



let tally = {
  date:'Total', flight: 'All Flights', 'passengerCount': passengerCount, 'forecastedCount': forecastedCount, forecastedFlightDoc: {}
}

list.unshift(tally)

// console.log('list ', list)
return list;
};

// departure list for flight schedule companion
export const selectOutboundFlights = state => {

    let forecastedFlights = [...state.flights.outboundForecastedFlights];       // forecast passenger flight count { flight, date, forecastedCount }
    let outboundFlights = [...state.flights.outboundFlights];                       // actual passenger flight count { flight, date, passengerCount }

    if(outboundFlights  == null || outboundFlights == undefined){ return [] }
    if(forecastedFlights == null || forecastedFlights == undefined){ return [] }

    // console.log('real flights ', realFlights)             // actual passenger flight count { flight, date, passengerCount }
    
    let passengerCount = 0;
    let forecastedCount = 0;

    let duplicateList = [];

    // console.log('forecasted flights ', forecastedFlights)

    // find duplicates in forecasted flights
    forecastedFlights.forEach((forecastedFlight) => {
      let count = 0;

      forecastedFlights.forEach((flight) => {
        if(forecastedFlight.flight == flight.flight){
          count++
        }
      }) 

      if(count > 1){
        duplicateList.push(forecastedFlight)
      }
    })

    // console.log('departures duplicate list ', duplicateList)

    // before processing, remove any duplicates from forecasted flights
    /*
    const uniqueList = Array.from(
      new Map(forecastedFlights.map(item => [item.flight, item])).values()
    );
    */

    //console.log('unique list ', uniqueList)

    let list = forecastedFlights.map(forecastedFlight => {

      // add forecasted passengers to total forecast flight count
      forecastedCount += forecastedFlight.passengerForecastCount;

      // extract flight number from forecasted flight
      let flightNumber = forecastedFlight.flight;

      // find outbound flight object if its exsists
      const outboundFlight = outboundFlights.find(outboundFlight => outboundFlight.flight === flightNumber);

      //console.log('forecastedFlight', forecastedFlight)
      //console.log('outboundFlight', outboundFlight)

      //console.log('real flight', realFlight)
      //console.log('flight ', flight)  

      if(outboundFlight == undefined){
        // this flight is forecasted but there are currently no passengers booked on the outbound flight
        return {
          date: forecastedFlight.date,
          flight: flightNumber,
          passengerCount: 0,
          forecastedCount: forecastedFlight.passengerForecastCount,
          forecastedFlightDoc: forecastedFlight
        };
      }
      else {

        // console.log('outbound flight ', outboundFlight)

        // increment passenger count
        passengerCount += outboundFlight.passengerCount;
        
        // create object combing flight and forecasted data
        return {
            date: forecastedFlight.date,
            flight: flightNumber,
            passengerCount: outboundFlight.passengerCount,
            forecastedCount: forecastedFlight.passengerForecastCount,
            forecastedFlightDoc: forecastedFlight
        };
    }
    });


    // add missing flights to the list
    outboundFlights.forEach((outboundFlight) => {
      //console.log('outbound flight ', outboundFlight.flight)
      // check if each outbound flight is in the forecasted list
      let found = list.some(flight => flight.flight === outboundFlight.flight);

      if(!found){
        // this flight is not in the forecasted list, add the missing flight
        list.push({
          date: outboundFlight.date,
          flight: outboundFlight.flight,
          passengerCount: outboundFlight.passengerCount,
          forecastedCount: null,
          forecastedFlightDoc: {}
        })
      }
    });

    /* process each flight into formatting for the table
    let list = state.flights.outboundFlights.map(flight => {

        // extract flight number
        let flightNumber = flight.flight;

        // find forecast flight count for this flight
        const forecastedFlightDoc = forecastedFlights.find(flight => flight.flight === flightNumber);
        const isForecasted = !!forecastedFlightDoc;

        // increment passenger count
        passengerCount += flight.passengerCount;
        forecastedCount += forecastedFlightDoc == undefined || forecastedFlightDoc.passengerForecastCount == undefined ? 0 : forecastedFlightDoc.passengerForecastCount;

        // create object combing flight and forecasted data
        return {
            date: flight.date,
            flight: flightNumber,
            passengerCount: flight.passengerCount,
            isForecasted: isForecasted,
            forecastedCount: forecastedFlightDoc == undefined || forecastedFlightDoc.passengerForecastCount == undefined ? null : forecastedFlightDoc.passengerForecastCount.toFixed(1),
            forecastedFlightDoc: forecastedFlightDoc
        };
    });
    */

    let tally = {
      date:'Total', flight: 'All Flights', 'passengerCount': passengerCount, 'forecastedCount': forecastedCount, forecastedFlightDoc: {}
    }

    list.unshift(tally)

    // console.log('list ', list)
    return list;
};

export const selectFlightStatus = state => state.flights.status;
export const selectFlightError = state => state.flights.error;
export default flightsSlice.reducer;
